import { render } from "./testList.vue?vue&type=template&id=5bec4211&scoped=true"
import script from "./testList.js?vue&type=script&lang=js"
export * from "./testList.js?vue&type=script&lang=js"

import "./testList.vue?vue&type=style&index=0&id=5bec4211&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bec4211"]])

export default __exports__